// BI date filters use the Nepal business day (Asia/Kathmandu), not the browser/UTC date.
const nepalDateFormat = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Kathmandu',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const nepalTodayKey = () => nepalDateFormat.format(new Date());

export const shiftDateKey = (dateKey, days) => {
  const date = new Date(`${dateKey}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};
